// Fallback for the Invoker Commands API (command/commandfor on buttons),
// native in Chrome 135, Firefox 144 and Safari 26.2.

const installed = new WeakMap();

export function invokerCommandsSupported() {
  return "command" in HTMLButtonElement.prototype;
}

function handleClick(event) {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest("button[commandfor]");
  if (!button || event.defaultPrevented || button.matches(":disabled")) return;

  // The form action wins, as it does natively.
  if (button.form && (button.type === "submit" || button.type === "reset")) {
    return;
  }

  const target = button.ownerDocument.getElementById(
    button.getAttribute("commandfor"),
  );
  if (!target) return;

  const attribute = button.getAttribute("command");
  if (!attribute) return;
  const command = attribute.startsWith("--")
    ? attribute
    : attribute.toLowerCase();
  if (
    command !== "show-modal" &&
    command !== "close" &&
    !command.startsWith("--")
  ) {
    return;
  }

  const commandEvent = new Event("command", { cancelable: true });
  Object.defineProperties(commandEvent, {
    command: { value: command },
    source: { value: button },
  });
  target.dispatchEvent(commandEvent);
  if (commandEvent.defaultPrevented) return;

  if (!(target instanceof HTMLDialogElement)) return;

  if (command === "show-modal" && target.isConnected && !target.open) {
    target.showModal();
  } else if (command === "close" && target.open) {
    target.close(button.hasAttribute("value") ? button.value : undefined);
  }
}

export function installInvokerCommandsFallback(root = document) {
  if (!installed.has(root)) {
    root.addEventListener("click", handleClick);
    installed.set(root, () => {
      root.removeEventListener("click", handleClick);
      installed.delete(root);
    });
  }
  return installed.get(root);
}

if (!invokerCommandsSupported()) installInvokerCommandsFallback();
